import { GET_OPTA_ESTIMATOR } from '../../constants/actions/policy';

export function getOptaEstimator(payload) {
    return {
        type: GET_OPTA_ESTIMATOR,
        payload,
    };
}
